/*
# -----------------------------------------------------------------------------
# Component: polTypeDataMixin.js
# Author: ssy@pst.sg
# Created Date: 20/Feb/2020
# Comments: Responsible for shared components - Policy Type Parameters
# -----------------------------------------------------------------------------
*/

import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export const polTypeDataMixin = {
  data() {
    return {
      sideFunction: [
        {
          text: 'Permit Business Class',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'polTypeBusCls' }
        },
        {
          text: 'Permit Clause',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'polTypeClause' }
        },
        {
          text: 'Permit Statistic Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'polTypeStatsType' }
        }
      ]
    }
  },
  methods: {
    doInit(pKey) {
      const apiURI = this.menu.polTypeParamList
      if (apiURI) {
        const params = {
          paramKey: pKey,
          paramString: ''
        }
        this.loading = true
        this.$http.get(expandURI(apiURI, params)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(result => {
              const convertList = {
                paramName: result.paramName,
                paramSub: result.paramSub
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  computed: {
    menu() {
      return this.$store.state.polTypeParam.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
